function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLivemapFilterTools = function SvgLivemapFilterTools(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 37.998,
    viewBox: "0 0 38 37.998"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9812"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h28v28H0z",
    "data-name": "Rectangle 4468",
    style: {
      fill: "none"
    },
    transform: "translate(5 5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.137 21.936-1.524-1.52 2.354-2.263-1.283-1.28-2.326 2.32L0 17.837l2.088-3.61A3 3 0 0 1 4.711 12.7h.149l1.192.056 2.3-2.3 2.249-2.188 2.139-2.1-.058-1.329a3.072 3.072 0 0 1 1.442-2.68L17.636 0l1.525 1.521-2.354 2.263 1.283 1.251 2.326-2.319 1.357 1.354-2.088 3.612A3 3 0 0 1 17.063 9.2h-.15l-1.191-.056-2.11 2.1-2.279 2.272-2.305 2.27.058 1.3a3.074 3.074 0 0 1-1.441 2.68l-3.506 2.169zm-.537-6.2 2.444 2.439L3.718 20.5l.579.518 2.992-1.858a2.285 2.285 0 0 0 1.055-1.96l-.029-1.69 7.154-7.189 1.554.081c.042 0 .088.006.142.006a2.268 2.268 0 0 0 1.907-1.113l1.751-3.04-.352-.355-2.325 2.324-2.446-2.44 2.327-2.321-.578-.515-3.022 1.829a2.284 2.284 0 0 0-1.052 1.959l.054 1.69-7.152 7.218-1.554-.084H4.58a2.267 2.267 0 0 0-1.907 1.112L.922 17.709l.351.35L3.6 15.74z",
    "data-name": "Path 11628",
    style: {
      fill: "#4da5b5",
      stroke: "#4da5b5",
      strokeWidth: ".5px"
    },
    transform: "translate(8 8.001)"
  })));
};
export default SvgLivemapFilterTools;